// extracted by mini-css-extract-plugin
export var miniCartDrawer = "NavCart-module--miniCartDrawer--CvdVk";
export var miniCartTitle = "NavCart-module--miniCartTitle--1XTdE";
export var cartIconContainer = "NavCart-module--cartIconContainer--WaPyc";